import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import Button from '../atoms/BaseButton';
import { ForumIcon } from '../atoms/Icons';
var ForumButton = function (_a) {
    var iconOnly = _a.iconOnly, offerListId = _a.offerListId, role = _a.role;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var handleClick = React.useCallback(function () { return navigate("/".concat(role, "/offer_lists/").concat(offerListId, "/forum")); }, [role, navigate, offerListId]);
    return iconOnly ? (React.createElement(IconButton, { onClick: handleClick, size: "large" },
        React.createElement(Tooltip, { title: t('labels.forum') },
            React.createElement(ForumIcon, null)))) : (React.createElement(Button, { onClick: handleClick },
        React.createElement(ForumIcon, null),
        t('labels.forum')));
};
export default ForumButton;
